import { PagedFilterAndSortedRequest } from '../../dto/pagedFilterAndSortedRequest';

export interface ServiceGroup {
  id: number;
  name: string;
  description: string;
}

export const InitialServiceGroup = {
  id: 0,
  name: '',
  description: '',
};

export interface PagedServiceGroupRequest extends PagedFilterAndSortedRequest {
  keyword?: string | null;
}
